import { NgModule } from "@angular/core";
import { CalendaringComponent } from "./calendaring.component";
import { S25CheckboxModule } from "../s25-checkbox/s25.checkbox.module";
import { S25ButtonComponent } from "../../standalone/s25.button.component";
import { CalendarTable } from "./calendaring.table.component";
import { DynamicContentComponent } from "../dynamic-content/dynamic.content.component";
import { S25LoadingInlineModule } from "../s25-loading/s25.loading.inline.module";
import { CalendaringAdminComponent } from "./calendaring.admin.component";
import { S25TableModule } from "../s25-table/s25.table.module";
import { CalendarEventDetailsComponent } from "./calendaring.event.details";
import { CalendarColumnValue } from "./calendaring.column.value";

@NgModule({
    declarations: [
        CalendaringComponent,
        CalendarTable,
        CalendaringAdminComponent,
        CalendarColumnValue,
        CalendarEventDetailsComponent,
    ],
    imports: [S25CheckboxModule, S25ButtonComponent, DynamicContentComponent, S25LoadingInlineModule, S25TableModule],
    exports: [
        CalendaringComponent,
        CalendarTable,
        CalendaringAdminComponent,
        CalendarColumnValue,
        CalendarEventDetailsComponent,
    ],
    providers: [
        CalendaringComponent,
        CalendarTable,
        CalendaringAdminComponent,
        CalendarColumnValue,
        CalendarEventDetailsComponent,
    ],
})
export class CalendaringModule {
    constructor() {}
}
